import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useAuth } from "../../context/AuthProvider";
import axios from "./../../api/axios";
import "./styles/AdminDashboard.css";

const AdminDashboard = () => {
  const { auth, hasAccess } = useAuth();
  const [pageViews, setPageViews] = useState([]);

  const adminLinks = [
    { path: "/admin/users", label: "Manage Users" },
    { path: "/admin/messages", label: "View Messages" },
    { path: "/admin/gallery", label: "View/Manage Gallery" },
    { path: "/admin/reviews", label: "Manage Reviews" },
    { path: "/admin/service-areas", label: "Manage Service Areas" },
  ];

  const iconMap = {
    "/admin/users": ["fa-user-shield", "fa-solid fa-table-cells-row-lock"],
    "/admin/messages": ["fa-envelope-open-text", "fa-solid fa-envelope"],
    "/admin/gallery": ["fa-file-image", "fa-images"],
    "/admin/reviews": ["fa-align-left", "fa-star"],
    "/admin/service-areas": ["fa-globe", "fa-map-location-dot"],
  };

  const pathToPageName = {
    "/": "Home",
    "/about": "About",
    "/contact": "Contact",
    "/services": "Services",
    "/pricing": "Pricing",
    "/portfolio": "Portfolio",
    "/blog": "Blog",
    "/privacy-policy": "Privacy Policy",
    "/terms-of-service": "Terms of Service",
    "/shopping-cart": "Shopping Cart",
    "/our-process": "Our Process",
    "/shipping-returns": "Shipping & Returns",
    // fallback to dynamic for product pages or others
  };
  

  return (
    <div className="admin-dashboard">
      <h1 className='admin-welcome'>
        <span>Welcome</span>&nbsp;
        <Link to="/admin/user/profile" className="dashboard-user-link">
          <span className="profile-icon-circle">
            <i className="fa-solid fa-user"></i>
          </span>
          <span className="dashboard-username">
            {auth.user.name || auth.user.username || auth.user.email || 'User'}
          </span>
          !
        </Link>
      </h1>


  <div className="admin-cards-container">
    {adminLinks.map(({ path, label }) => {
      // 🔒 Hide Service Areas page unless site admin
      if (path === "/admin/service-areas" && auth.user.role !== "siteadmin") {
        return null;
      }

      return hasAccess(path) ? (
        <Link key={path} to={path} className="admin-card">
          {/* Left Icon */}
          {iconMap[path]?.[0] && (
            <div className="admin-card-icon icon-left">
              <i className={`fa-solid ${iconMap[path][0]}`}></i>
            </div>
          )}

          {/* Right Icon */}
          {iconMap[path]?.[1] && (
            <div className="admin-card-icon icon-right">
              <i className={`fa-solid ${iconMap[path][1]}`}></i>
            </div>
          )}

          {/* Main Content */}
          <div className="admin-card-body">
            <h2>{label}</h2>
          </div>
        </Link>
      ) : null;
    })}
  </div>

    </div>
  );
};

export default AdminDashboard;